// extracted by mini-css-extract-plugin
export var container = "_fd-0";
export var icon = "_fd-1";
export var text = "_fd-2";